export default __webpack_public_path__ + "static/media/four-card-feature-thumbnail.ec959ad9.png";